import {
  CashMovement,
  CashMovementType,
} from "@towersystems/roam-common/lib/generated-types";
import { useCallback } from "react";
import { FlatList } from "react-native";
import { View } from "react-native-ui-lib";
import { Divider } from "@towersystems/roam-common-native";
import { formatDateToCalendar } from "../../../../utilities/date/format-date";
import { moneyToFormattedString } from "../../../../utilities/money";
import { Text } from "@towersystems/roam-common-native";

export interface CashMovementListProps {
  cashMovements: CashMovement[];
}

export const CashMovementList = ({ cashMovements }: CashMovementListProps) => {
  const renderItem = useCallback(({ item }: { item: CashMovement }) => {
    const color =
      item.type == CashMovementType.CASH_OUT ? "destructive" : "success";
    return (
      <View row>
        <View flex>
          <Text variant="heading1">{item.type}</Text>
          {item.note ? <Text variant="caption">"{item.note}"</Text> : null}
          <Text variant="heading4" color="subdued">
            {`${formatDateToCalendar(item.createdAt)}, by ${
              item.userIdentifier ?? "Unknown User"
            }`}
          </Text>
        </View>
        <View>
          <Text variant="heading1" color={color}>
            {moneyToFormattedString(item.amount)}
          </Text>
        </View>
      </View>
    );
  }, []);

  return (
    <FlatList
      scrollEnabled={false}
      ItemSeparatorComponent={Divider}
      data={cashMovements}
      renderItem={renderItem}
    ></FlatList>
  );
};
